import { render } from "./SignupPage.vue?vue&type=template&id=4f7b895d&scoped=true"
import script from "./SignupPage.vue?vue&type=script&lang=js"
export * from "./SignupPage.vue?vue&type=script&lang=js"

import "./SignupPage.vue?vue&type=style&index=0&id=4f7b895d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7b895d"]])

export default __exports__